import SsHeadline from "../../layout/SsHeadline";
import { FrontPasswordResetRequestForm } from "./RequestForm";
import React, { FC } from "react";
import { goLoginPage } from "lib/frontRouting";
import { infoToast } from "lib/toast";
import { useRouter } from "next/router";
import ContentSection from "components/front/layout/ContentSection";

export type Props = Record<string, never>;
const PasswordResetRequestSection: FC<Props> = () => {
  const router = useRouter();
  const onSuccess = async (): Promise<void> => {
    await goLoginPage(router);
    infoToast("パスワード再設定用のURLをメールにて送信しました。");
  };
  return (
    <ContentSection $pcWidth="500px">
      <SsHeadline label="パスワード再設定" color="black" />
      <p>登録されたメールアドレスをご入力してください。</p>
      <p>パスワード再設定用のURLをメールにて送信します。</p>
      <FrontPasswordResetRequestForm onSuccess={onSuccess} />
    </ContentSection>
  );
};
export default PasswordResetRequestSection;
